import React from 'react';
import * as PropTypes from 'prop-types';

import Interpolate from '@doist/react-interpolate';
import {interpolate} from 'as-ui-kit/utils/strings';
import RadioButton from '@components/radio-button';
import Badge from '@components/badge';

import { useLocalized } from 'utils/useLocalized';
import styles from './styles.modules.scss';
import i18nStrings from './strings';



const PeriodSelector = ({period, price, withProfit, isPayCard, isSelected, onClick}) => {
    const strings = useLocalized(i18nStrings);
    return (
        <div
            className={styles['wrapper']}
            onClick={onClick}
        >
            <RadioButton inputProps={{checked: isSelected}}>
                {''}
            </RadioButton>
            <div  className={styles['content']}>
                <div className={styles['title-access']} >
                    {strings[period].title}
                    <div className={styles['access']}>
                        {strings[period].accessDescription}
                    </div>
                </div>
                {price.base == price.personal ? (
                    <div className={styles['price']}>
                        <Interpolate
                            mapping={{
                                cross: (<s className={styles['cross']}/>),
                                atis: <span className={isPayCard && styles['gray']}/>,
                                rub: <span className={!isPayCard && styles['gray']}/>,
                                gray: <span className={styles['gray']}/>
                            }}
                            string={interpolate(strings.price, { base: price.base, personal: price.personal})}
                        />
                    </div>
                ): (
                    <div className={styles['price']}>
                        <Interpolate
                            mapping={{
                                cross: (<s className={styles['cross']}/>),
                                atis: <span className={isPayCard && styles['gray']}/>,
                                rub: <span className={!isPayCard && styles['gray']}/>,
                                gray: <span className={styles['gray']}/>
                            }}
                            string={interpolate(strings.discountPrice, { base: price.base, personal: price.personal})}
                        />
                    </div>
                )}

                <div className={styles['badges']}>
                    {price.discount > 0 && (
                        <Badge
                            size="small"
                        >
                            {`${strings.discount} ${price.discount}%`}
                        </Badge>
                    )}
                    {withProfit && (
                        <Badge
                            size="small"
                        >
                            {interpolate(strings.profit, {percent: 73})}
                        </Badge>
                    )}
                </div>


            </div>
        </div>
    );
};

export default PeriodSelector;

PeriodSelector.propTypes = {
    isPayCard: PropTypes.bool,
    isSelected: PropTypes.bool,
    period: PropTypes.number,
    price: PropTypes.number,
    withProfit: PropTypes.bool,
    onClick: PropTypes.func,
};
